import React, { useState } from 'react'

// react router
import { Link } from 'react-router-dom';

// bootstrap
import {
    Image,
} from "react-bootstrap";

// icons
import { AiOutlinePlus, AiOutlineMinus, AiOutlineClose } from "react-icons/ai";

// when no image
import noImgFoundImg from 'assets/images/no-img.png'

export default function CartListSec(props) {
    // props
    const {
        dataItem,

        cartImages,

        handleUpdate,
        handleDelete
    } = props

    // states
    const [productQuantity, setProductQuantity] = useState(dataItem?.quantity)

    // on values chagne
    const handleQuantityChange = (ev, item) => {
        const inpVal = ev.target.value

        setProductQuantity(inpVal) //setting input value

        if (inpVal !== "" && inpVal !== "0") {
            handleUpdate(inpVal, item) // updating cart
        }
        // if (inpVal && parseInt(inpVal) !== 0) {
        // }
    }

    // on blur of quantity field
    const handleQuantityBlur = ev => {
        const inpVal = ev.target.value

        if (inpVal === "" || inpVal === "0") {
            setProductQuantity(dataItem?.quantity) //setting input value
        }
    }

    // increase value
    const handleValueIncrease = (ev, item) => {
        ev.preventDefault()
        let val = parseInt(productQuantity) + 1
        setProductQuantity(val) //setting input value

        handleUpdate(val, item) // updating cart
    }

    // increase value
    const handleValueDecrease = (ev, item) => {
        ev.preventDefault()

        if (productQuantity > 1) {
            const val = parseInt(productQuantity) - 1
            setProductQuantity(val) //setting input value

            handleUpdate(val, item) // updating cart
        }
    }


    return (
        <React.Fragment>
            <tr>
                <td className="py-3">
                    <div className="d-flex">
                        {/* img sec */}
                        <div className="img-sec">
                            <Link to={`product/${dataItem.product_name}?id=${dataItem.product_id}`} className="text-decoration-none d-block">
                                {
                                    cartImages ? (
                                        <Image
                                            src={cartImages[dataItem.cart_id] || noImgFoundImg}
                                            alt="product"
                                            fluid
                                        />
                                    ) : null
                                }
                            </Link>
                        </div>

                        <div className="text-sec media-body ps-3">
                            <Link to={`product/${dataItem.product_name}?id=${dataItem.product_id}`} className="name st-fs-17 st-fw-600 mb-2 text-decoration-none d-inline-block text-black">{dataItem.product_name}</Link>
                            <div className="selectedoptions st-fs-15">
                                {
                                    dataItem.variant_name ? (
                                        <React.Fragment>
                                            {
                                                (dataItem.variant_name.search(",") !== -1) ? dataItem.variant_name.split(",").map((item, index) => (
                                                    <p key={index} className="mb-0 mt-1">{item}</p>
                                                )) :(
                                                    <p className="mb-0 mt-1">{dataItem.variant_name}</p>
                                                )
                                            }
                                        </React.Fragment>
                                    ) : null
                                }
                            </div>
                        </div>
                    </div>
                </td>

                <td width={150} className="text-center py-3">
                    <div className="quantity-selector d-inline-flex">
                        <input
                            type="number"
                            value={productQuantity}
                            onChange={ev => handleQuantityChange(ev, dataItem)}
                            onBlur={handleQuantityBlur}
                        />
                        <div className="btns">
                            <span className="plus d-flex align-items-center justify-content-center" onClick={ev => handleValueIncrease(ev, dataItem)}>
                                <AiOutlinePlus />
                            </span>
                            <span className="minus d-flex align-items-center justify-content-center" onClick={ev => handleValueDecrease(ev, dataItem)}>
                                <AiOutlineMinus />
                            </span>
                        </div>
                    </div>
                </td>

                <td width={150} className="text-center py-3">
                    <p className="mt-1 st-fs-15">
                        <span className="st-fw-600">{productQuantity}</span> <span className="mx-1">x</span> {dataItem.display_price}
                    </p>
                </td>

                <td className="text-end py-3">
                    <div className="icon d-inline-flex align-items-center text-danger cursor-pointer" onClick={ev => handleDelete(ev, dataItem)}>
                        <AiOutlineClose />
                        <span className="ms-1">Remove</span>
                    </div>

                    <div className="price st-fs-17 mt-4">
                        <p className="mb-0 st-fw-600">{dataItem.total_price}</p>
                    </div>
                </td>
            </tr>
        </React.Fragment>
    )
}
